const num = (n) => Number(n).toLocaleString();

export const BRANDED_STAGES = [
  { key: "reading", label: "Reading the CV", detail: (d) => (d.chars ? `${num(d.chars)} characters` : null) },
  {
    key: "redacting",
    label: "Removing personal data",
    detail: (d) => (d.removed ? `${d.removed} identifier${d.removed === 1 ? "" : "s"} removed` : null),
  },
  { key: "composing", label: "Writing the profile", detail: (d) => d.model || null },
  {
    key: "assembling",
    label: "Assembling the document",
    detail: (d) => (d.experiences != null ? `${d.experiences} experience${d.experiences === 1 ? "" : "s"} · ${d.skills || 0} skills` : null),
  },
  { key: "rendering", label: "Rendering the PDF" },
  { key: "done", label: "Done" },
];

export const brandedStageLabel = (stage) =>
  BRANDED_STAGES.find((s) => s.key === stage)?.label || "Writing the Squarehub CV";

export const brandedStageDetail = (stage, progress) => {
  const detail = BRANDED_STAGES.find((s) => s.key === stage)?.detail;
  return detail ? detail(progress || {}) : null;
};

export const brandedStageProgress = (stage) => {
  const index = BRANDED_STAGES.findIndex((s) => s.key === (stage || "reading"));
  return (Math.max(0, index) / (BRANDED_STAGES.length - 1)) * 100;
};

export const brandedErrorCopy = ({ errorKind, error, stalled }) => {
  if (stalled) {
    return {
      title: "This generation stopped responding",
      detail: "The job has not reported progress for several minutes. It may have been interrupted.",
    };
  }
  if (errorKind === "permanent") {
    return {
      title: "The Squarehub CV could not be generated",
      detail: error || "The AI service could not find a CV to work from.",
    };
  }
  return {
    title: "The Squarehub CV could not be generated",
    detail: error || "The AI service did not respond. Try again.",
  };
};
